import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { CustomsError } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminCreateCustomsError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (customsErrorData: Partial<CustomsError>) => {
      return apiClient.customsError.createCustomsError.mutation({ body: customsErrorData });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-customs-errors-list'] });
      toast.success('Customs error created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating customs error!');
    },
  });
};
